import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { notificationsWorkspaceSelector } from '../../../redux/selectors/notifications';
import { appRoutes } from '../../../path';
import KubitTooltip from '../../../components/KubitTooltip';
import * as SecondaryNavUI from '../../../components/SecondaryNav/SecondaryNavUI';
import { SecondaryNavRouteLink } from '../../../components/SecondaryNav';
import { theme } from '../../../styles/theme';

interface IProps {
  id: string;
  name: string;
  mouseOverLink: string;
  setMouseOverLink: (value: string) => void;
}

const LinkContent = styled(SecondaryNavUI.StyledNavItem)<{
  $hasHighlights: boolean;
}>`
  ${({ $hasHighlights }) =>
    $hasHighlights &&
    `
    padding-left: 3px;
  `}
`;

export default ({ name, id, mouseOverLink, setMouseOverLink }: IProps) => {
  const notificationsMemoSelector = useMemo(notificationsWorkspaceSelector, []);
  const hasHighlights = useSelector((state) =>
    notificationsMemoSelector(state, id),
  );

  return (
    <KubitTooltip placement="bottom-start" noOpenDelay={true} content={name}>
      <SecondaryNavUI.LinkContainer
        onMouseEnter={() => setMouseOverLink(id)}
        onMouseLeave={() => setMouseOverLink('')}
      >
        <SecondaryNavRouteLink
          url={appRoutes.workspaces.workspace(id)}
          mouseOverLink={mouseOverLink}
        >
          <LinkContent $hasHighlights={hasHighlights} $isInteractive={true}>
            {hasHighlights && (
              <svg height="4" width="4">
                <circle
                  cx="2"
                  cy="2"
                  r="2"
                  stroke={theme.colors.secondary800}
                  strokeWidth="0"
                  fill={theme.colors.secondary800}
                />
              </svg>
            )}
            <SecondaryNavUI.TruncatedBlock>
              {name}
            </SecondaryNavUI.TruncatedBlock>
          </LinkContent>
        </SecondaryNavRouteLink>
      </SecondaryNavUI.LinkContainer>
    </KubitTooltip>
  );
};
